import { useState, useCallback } from 'react';

/**
 * Custom React hook for managing IPv4 address using localStorage.
 * 
 * @returns {Object} ip4 - The current IPv4 address.
 * @returns {Function} setIp4 - Function to save IPv4 address to localStorage and state.
 */
const useIp4 = () => {

    const getStoredIp = () => {
        try {
            const stored = localStorage.getItem('ipv4');
            return stored ? JSON.parse( stored ) : null;
        } catch ( error ) {
            console.error( 'Failed to parse IPv4 from localStorage:', error );
            return null;
        }
    };

    const [ip4, setIp4State] = useState( getStoredIp() )

    /**
     * Saves the IPv4 address to localStorage and updates the state.
     * 
     * @param {string|Object} ipData - The IP address or an object containing it.
     */
    const setIp4 = useCallback(( ipData ) => {
        const ip = typeof ipData === 'string' ? ipData : ipData?.ip;

        if ( !ip || typeof ip !== 'string' ) {
            console.warn( 'Invalid IP data provided to setIp4:', ipData );
            return;
        }

        try {
            localStorage.setItem( 'ipv4', JSON.stringify( ip ) );
            setIp4State( ip );
        } catch ( error ) {
            console.error( 'Failed to save IPv4 to localStorage:', error );
        }
    }, []);

    return { 
        setIp4,
        ip4
    }
}

export default useIp4;